import type { AxiosError } from 'axios';
import get from 'lodash/get';

import { isTimeoutError } from 'src/modules/seek-api-request';
import { hashToUserQueryId } from 'src/modules/seek-jobs-analytics';
import createApiClient from 'src/modules/seek-jobs-api-client';

import { selectLocale, selectPageSize } from '../selectors';
import type { TypedThunkAction } from '../types';

import { FETCH_SEARCH_RESULTS_ERROR } from './types';

const api = createApiClient();

export const fetchCount =
  ({
    apiQuery = {},
    brand,
    country = 'AU',
    zone = 'anz-1',
    cookies,
    userQueryId,
    userAgent,
    tries = 2,
    timeout,
    visitorId,
    serverProps,
    isAuthenticated = false,
    newSince,
    isSQCEnabled = false,
  }: any): TypedThunkAction<Promise<number>> =>
  (dispatch, getState) => {
    const state = getState();
    const {
      user: { testHeaders, userClientId, sessionId },
    } = state;

    const pageSize = selectPageSize(state);
    const locale = selectLocale(state);

    return api.jobs
      .count({
        brand,
        searchParams: { ...apiQuery, pageSize },
        country,
        zone,
        cookies,
        requestId: state.location.requestId,
        timeout,
        solId: visitorId,
        userQueryId,
        userClientId,
        userAgent,
        sessionId,
        serverProps,
        testHeaders,
        locale,
        isAuthenticated,
        newSince,
        shouldIncludeQueryHints: state.results.shouldIncludeQueryHints,
        isSQCEnabled,
      })
      .catch((err: AxiosError) => {
        dispatch({
          type: FETCH_SEARCH_RESULTS_ERROR,
        });

        const retryUserQueryId = hashToUserQueryId({
          query: apiQuery.normalisedQuery,
        });

        if (get(err, 'response.status') === 400) {
          return {
            totalCount: 0,
            data: [],
          } as any;
        }

        if (isTimeoutError(err) || get(err, 'response.status', 0) >= 500) {
          if (tries === 1) {
            throw err;
          }

          return fetchCount({
            apiQuery,
            country,
            zone,
            cookies,
            userQueryId: retryUserQueryId,
            visitorId,
            tries: tries - 1,
            serverProps,
            isAuthenticated,
            isSQCEnabled,
          })(dispatch, getState, null);
        }

        throw err;
      });
  };
